import { CheckboxButton } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './CheckboxButtonsMultiple.css';

interface ICheckboxButtonsStackProps {
  text: string;
  value: string;
}

export interface ICheckboxButtonsMultipleProps {
  stack: ICheckboxButtonsStackProps[];
  name: string;
  value?: string;
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
}

export class CheckboxButtonsMultiple extends React.PureComponent<ICheckboxButtonsMultipleProps> {
  public render() {
    const { stack } = this.props;

    return (
      <div className={styles['checkbox_buttons_multiple']} data-mark="CheckboxButtonsMultiple">
        {stack.map(this.getCheckboxButton)}
      </div>
    );
  }

  private getCheckboxButton = (radioButtonProps: ICheckboxButtonsStackProps) => {
    const { value, text } = radioButtonProps;

    return (
      <span className={styles['checkbox_button']}>
        <CheckboxButton
          value={String(value)}
          label={text}
          name={this.props.name}
          onChange={this.props.onChange}
          checked={String(value) === this.props.value}
        />
      </span>
    );
  };
}
